import { useRef, useEffect, useMemo } from 'react';
import { debounce } from 'lodash';

export const useDebounce = (callback: () => void, wait: number) => {
  const ref = useRef<typeof callback>(undefined);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, wait);
  }, [wait]);

  return debouncedCallback;
};
